<template>


  <div class="container">
      <h3 class="heading">المربع السكني</h3>

      <form @submit.prevent="postinfo">

<div class="mb-3 input-in-con  ">
           <div v-if="err">
  <div v-if="err.district"  class="alert alert-danger" role="alert"> {{ err.district[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">الحي</label>
 <select class="form-select " aria-label="Default select example" v-model="formdata.district_name" >
  <option disabled selected>اختر الحي</option>
  <option  v-for="key in formdata2" >{{key.name}}</option>
</select>
</div>


  <div class="mb-3 input-in-con">
     <div v-if="err">
  <div v-if="err.name"  class="alert alert-danger" role="alert"> {{ err.name[0]}}</div>
</div>
  <label for="exampleFormControlInput1" class="form-label">اسم المربع السكني</label>
  <input type="text" class="form-control" id="exampleFormControlInput1" placeholder="ادخل الاسم " v-model="formdata.name">
</div>

<div class="flex last">
  <button  class="btn btn-primary">اضافة</button>
</div>
      </form>

  </div>

  

</template>

<script>
import  geturl  from "@/comp/geturl";

export default {
name: "EditRes",
props:['id'],
data(){
  return{
    formdata:{
      district: null,
      name: '',
      district_name: '',
    },
      temformdata2: null,
     formdata2:null,
     err:null
    
  }
},
mounted(){

    // Get housing_box 
       fetch(geturl()+"housing_box/",{
      headers: {"Content-Type": "application/json"},
       })
       .then(res => res.json())
       .then(data => {this.formdata = data})
       
       // Get specific housing_box
       this.formdata = this.formdata.filter((e)=>{
           return e.id == this.id
       })
       

       fetch(geturl()+"district/", {
      
      headers: {"Content-Type": "application/json"},
      })
      .then(res => res.json())
      .then(data => {this.formdata2 = data
      })
    

},
methods: {
    postinfo(){
    this.temformdata2 = this.formdata2.filter((e) => {
        return e.name === this.formdata.district_name
      })
            if(this.temformdata2.length>0)
       this.formdata.district =  this.temformdata2[0].id 
      
    fetch(geturl()+"housing_box/"+this.id+"/", {
         method: "PUT",
      headers: {"Content-Type": "application/json"},
      body: JSON.stringify(this.formdata)
      })
      .then(res => res.json())
      .then(data => {if(data.error)
      this.err = data.error.details
      else
            this.$router.push({name:'ViewRes' })
      }) 
    },
   
}
}
</script>

<style>

</style>